import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import StyledButton from 'components/shared/StyledButton/StyledButton';

import styles from './LostDamagedPalletsStepFooter.module.css';

type LostDamagedPalletsStepFooterProps = {
   onNextClick: () => void;
   onPrevClick: () => void;
   nextButtonText: string;
   className?: string;
};

const LostDamagedPalletsStepFooter = ({
   onNextClick,
   onPrevClick,
   nextButtonText,
   className,
}: LostDamagedPalletsStepFooterProps) => {
   const { t } = useTranslation();

   return (
      <div className={classNames(styles.buttonsContainer, className)}>
         <StyledButton
            variant="text"
            text={t('reportDamage.stepFooter.back')}
            onClick={onPrevClick}
         />
         <StyledButton variant="filled-primary" text={nextButtonText} onClick={onNextClick} />
      </div>
   );
};

export default LostDamagedPalletsStepFooter;
